import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";

class AuthenticateRedirect extends Component {
  state = {
    authenticated: null
  };

  componentDidMount() {}

  render = () => (
    <React.Fragment>
      <Helmet title="Authenticate" />
      <div className="content">
        <div className="container">
          <div className="row">
            <div className="col-12">
              {this.state.authenticated ? <Redirect to="/" /> : ""}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = state => {
  return {};
};

export default {
  component: connect(mapStateToProps)(AuthenticateRedirect)
};
